module.exports = __webpack_public_path__ + "img/calendar.40aa439d.svg";